import { MessageCircle } from "lucide-react";
import { WHATSAPP_LINK } from "@/data/content";

export default function FloatingWhatsApp() {
  return (
    <a
      data-testid="floating-whatsapp"
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="group fixed bottom-6 right-6 z-50 hidden md:block"
    >
      <span className="absolute inset-0 inline-flex animate-ping rounded-full bg-[#25D366] opacity-30" />
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform duration-300 group-hover:scale-110">
        <MessageCircle className="h-6 w-6" />
      </span>
    </a>
  );
}
